import React from 'react';

const ProductsSection = () => {
  const products = [
    {
      id: 1,
      image: '/images/Bitejoy/bitejoyp1.jpeg',
      title: 'Date Dry Fruit Chocolate',
      description:
        'A perfect blend of natural sweetness and rich nutrition. Crafted using premium dates sourced from Dubai, fine chocolate, and carefully selected dry fruits, this chocolate delivers taste with wholesome goodness.',
      hasBoxShadow: true,
    },
    {
      id: 2,
      image: '/images/Bitejoy/bitejoyp2.jpeg',
      title: 'Peanut Butter Dry Fruit Bites',
      description:
        "Our Peanut Butter Dry Fruit Bites are power-packed treats designed for those who love bold flavors with nutrition. Made using creamy peanut butter, premium dates, rich, and crunchy dryfruits, these bites are both indulgent and energizing. We proudly offer 3 delicious flavours in our Peanut Butter Bites range: Chocolate Flavour – Classic, rich, and indulgent White Chocolate Flavour Smooth, creamy, and mildly sweet Mango Flavour A unique fruity twist with tropical freshness",
      hasBoxShadow: false,
    },
    // {
    //   id: 3,
    //   image: '/images/Bitejoy/bitejoyp3.jpeg',
    //   title: 'Date Dry Fruit Chocolate',
    //   description:
    //     'A perfect blend of natural sweetness and rich nutrition. Crafted using premium dates sourced from Dubai, fine chocolate, and carefully selected dry fruits, this chocolate delivers taste with wholesome goodness.',
    //   hasBoxShadow: true,
    // },
  ];

  const productsRow2 = [
    {
      id: 4,
      image: '/images/Bitejoy/1767698886587.jpg',
      title: 'Date Dry Fruit Chocolate',
      description:
        'A perfect blend of natural sweetness and rich nutrition. Crafted using premium dates sourced from Dubai, fine chocolate, and carefully selected dry fruits, this chocolate delivers taste with wholesome goodness.',
      hasBoxShadow: false,
    },
    {
      id: 5,
      image: '/images/Bitejoy/1767899450924.jpg',
      title: 'Peanut Butter Dry Fruit Bites',
      description:
        "Our Peanut Butter Dry Fruit Bites are power-packed treats designed for those who love bold flavors with nutrition. Made using creamy peanut butter, premium dates, rich, and crunchy dryfruits, these bites are both indulgent and energizing. We proudly offer 3 delicious flavours in our Peanut Butter Bites range: Chocolate Flavour – Classic, rich, and indulgent White Chocolate Flavour Smooth, creamy, and mildly sweet Mango Flavour A unique fruity twist with tropical freshness",
      hasBoxShadow: true,
    },
  ];

  return (
    <div className="container my-5" id="products">
      <section className="text-center" id="opinion">
        <h2 style={{ marginBottom: '30px' }}>Our Products</h2>

        {/* First Row */}
        <div className="row mt-6">
          {products.map((product) => (
            <div
              key={product.id}
              className={`col-md-6 mb-md-0 mb-4 mt-4 ${
                product.hasBoxShadow ? 'product-card' : ''
              }`}
            >
              <img
                src={product.image}
                alt={product.title}
                className="mb-4 product-image"
              />
              <h5 className="mb-3">{product.title}</h5>
              <p>
                <br />
              </p>
              {product.description}
              <p>
                <br />
              </p>
            </div>
          ))}
        </div>

        {/* Second Row */}
        {/* <div className="row mt-4">
          {productsRow2.map((product) => (
            <div
              key={product.id}
              className={`col-md-4 mb-md-0 mb-4 mt-4 ${
                product.hasBoxShadow ? 'product-card' : ''
              }`}
            >
              <img
                src={product.image}
                alt={product.title}
                className="mb-4 product-image"
              />
              <h5 className="mb-3">{product.title}</h5>
              <p>
                <br />
              </p>
              {product.description}
              <p>
                <br />
              </p>
            </div>
          ))}
          <div className="col-md-4 mb-0"></div>
        </div> */}
      </section>
    </div>
  );
};

export default ProductsSection;
